import Dashboard from 'pages/Dashboard';

// Authentication

import Login from 'pages/Authentication/Login';
import ForgotPassword from 'pages/Authentication/ForgotPassword';

import ResetPassword from 'pages/Authentication/ResetPassword';
import Logout from 'pages/Authentication/Logout';

import Categories from 'Category/CatergoryListing';
import Events from 'Events/EventListing';
import EventsHistory from 'EventsHistory/EventListing';
import ProductListing from 'pages/ProductListing';

import UpdateProfile from 'pages/Authentication/UpdateProfile';

import StockMangement from 'pages/StockManagement';
import Festivals from 'Festivals/FestivalListing';

import Guests from 'Guests/GuestListing';
import AfterParties from 'AfterParty/AfterPartyListing';
import HistoryAfterParties from 'AfterPartyHistory/AfterPartyListing';
import Venue from 'Venue/VenueListing';
import Restaurant from 'Restaurant/RestaurantListing';
import Club from 'Club/ClubListing';

import SuggestedFestivals from 'pages/SuggestedFestivals/FestivalListing';
import SuggestedVenue from 'pages/SuggestedVenue/VenueListing';
import Users from 'pages/Users/UsersListing';
import BookTable from 'BookTable/BookTableListing';
import PendingUsers from 'pages/PendingUsers/UsersListing';
import RejectedUsers from 'pages/RejectedUsers/UsersListing';
import restaurantBookTable from 'RestaurantBookTable/BookTableListing';
import ApprovedGuest from 'AfterParty/ApprovedGuestsListing';
import GuestsWaitList from 'AfterParty/GuestsWaitList';

const authProtectedRoutes = [
  {path: '/dashboard', component: Dashboard},
  {path: '/update-profile', component: UpdateProfile},

  {path: '/logout', component: Logout},

  {path: '/categories', component: Categories},
  {path: '/venue', component: Venue},
  {path: '/restaurant', component: Restaurant},
  {path: '/club', component: Club},

  {path: '/suggestedVenue', component: SuggestedVenue},

  {path: '/events', component: Events},
  {path: '/history-events', component: EventsHistory},

  {path: '/guests', component: Guests},

  {path: '/booktable', component: BookTable},
  {path: '/restaurantbooktable', component: restaurantBookTable},

  {path: '/users', component: Users},

  {path: '/festivals', component: Festivals},
  {path: '/suggested-festivals', component: SuggestedFestivals},

  {path: '/pending-users', component: PendingUsers},
  {path: '/rejected-users', component: RejectedUsers},

  {path: '/after-party', component: AfterParties},
  {path: '/afterpartyhistory', component: HistoryAfterParties},
  {path: '/approved-guests', component: ApprovedGuest},
  {path: '/guestsWaitlist', component: GuestsWaitList},

  {path: '/products', component: ProductListing},

  {path: '/stock-management', component: StockMangement},
];

const publicRoutes = [
  // Authentication
  {path: '/login', component: Login},
  {path: '/forgot-password', component: ForgotPassword},
  {path: '/reset-password/:token', component: ResetPassword},
];

export {authProtectedRoutes, publicRoutes};
